export enum PaymentPlatform {
  Airwallex = "airwallex",
  Stripe = "stripe",
}
